import React from 'react'
import { Button } from '@drifthq/tide-core'
import googleLogo from 'images/google.svg'

const GoogleOauth = ({ onConnectClick }) => {
  return <div className="setup-meetings-calendar" onClick={onConnectClick}>
    <img alt="" className="logo calendar-logo" src={googleLogo} />
    <label>Google Calendar</label>
    <Button
      type="primary"
      size="small"
    >
      Connect
    </Button>
  </div>
}

export default GoogleOauth



// WEBPACK FOOTER //
// ./src/layouts/MeetingsStepWithPrime/GoogleOauth/component.js